import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { ChecklistSetupComponent } from './checklist-setup.component';


const routes: Routes = [
  {
    path: '',
    component: ChecklistSetupComponent,
    canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChecklistSetupRoutingModule { }
